import { render, staticRenderFns } from "./ProducaoPJForm.vue?vue&type=template&id=67b4eed6&scoped=true"
import script from "./ProducaoPJForm.vue?vue&type=script&lang=js"
export * from "./ProducaoPJForm.vue?vue&type=script&lang=js"
import style0 from "./ProducaoPJForm.vue?vue&type=style&index=0&id=67b4eed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b4eed6",
  null
  
)

export default component.exports